import { getSitePages } from '@gik/api/legal';
import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { PageHeadKeys } from '@gik/core/hocs/PageHeadKeys';
import { withTitle } from '@gik/core/hocs/withTitle';
import { ProductsSitemapPage } from '@gik/core/pages/ProductsSitemap';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import Head from '@/components/Head';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function ProductsSitemapPageComp({ fallback }: FallbackProps<unknown>) {
  return withTitle(
    'Products Sitemap',
    <SWRConfig value={{ fallback }}>
      <Head>
        <meta name="robots" key={PageHeadKeys.META_ROBOTS} content="index,follow" />
      </Head>
      <ProductsSitemapPage />
    </SWRConfig>
  );
}

ProductsSitemapPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps(): Promise<StaticProps<string[]>> {
  const sitePages = getSitePages();

  const json = await sitePages.json;

  return baseFallback({ [sitePages.key]: json }, undefined, ISRRevalidateTimeout.sitemapSlow);
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
